import {Error, ValidationResult, Validator} from '@/type/validation/result';
import {全角のみ, 必須入力, 日付書式} from '@/type/validation/validator';
import moment from 'moment';
import {取込履歴検索条件型} from '@/type/external/request/取込履歴検索条件';
import {外部連携移動検索条件型} from '@/type/external/request/外部連携移動検索条件';

export default class 外部連携取込履歴検索条件チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor(検索条件: 取込履歴検索条件型) {
    const 検索条件チェック = new ValidationResult(取込履歴検索条件Validators);
    検索条件チェック.validate(検索条件);
    this.単項目チェック結果 = 検索条件チェック.getErrors;
    this.相関チェック結果 = 相関チェック(検索条件);
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .some((error) => error.name === name);
  }
}

const 取込日FromValidators = {
  name: '取込日From',
  constraints: [
    {method: 必須入力, message: '取込日の開始日を入力してください'},
    {method: 日付書式, message: '取込日の開始日の書式を正しく入力してください'},
  ],
};

const 取込日ToValidator = {
  name: '取込日To',
  constraints: [
    {method: 日付書式, message: '取込日の終了日の書式を正しく入力してください'},
  ],
};


const 取込履歴検索条件Validators: Validator[] = [
  取込日FromValidators,
  取込日ToValidator,
];


function 相関チェック(検索条件: 取込履歴検索条件型): Error[] {
  const errors: Error[] = [];
  if (moment(検索条件.取込日To).isBefore(moment(検索条件.取込日From), 'day')) {
    errors.push({index: 1, message: '取込日を正しく入力してください', constraint: '', name: '取込期間'});
  }
  return errors;
}
